module.exports = __webpack_public_path__ + "media/01.45c4c0f6.mp3";